import { Component, OnInit, Input } from '@angular/core';
import { DrawStampDefaults, LeadToolsHelper } from '../../../models/configuration/draw/annotation-defaults.model';
import { DrawParameterObj } from '../../../models/configuration/draw/annotation-defaults.model';
import { cfgDrawParameter } from '../../../models/configuration/draw/annotation-defaults.model';
import { TdoColorPickerEvent } from '../../../tdo-controls/common/tdo-color-picker/models/tdo-color-picker.event';
import { DrawDefaultsService } from '../draw-defaults/draw-defaults.service';
import { FontStyle } from '../../../models/configuration/draw/annotation-defaults.model';
import {TdoDropdownChange} from '../../../tdo-controls/common/tdo-dropdown-v2/models/tdo-dropdown-change';
import {ConfigurationService} from '../configuration.service';
import { MatSnackBar } from '@angular/material/snack-bar';

export enum StampLocation {
  None = 0,
  UpperLeft = 1,
  UpperRight = 2,
  BottomLeft = 3,
  BottomRight = 4
}
const ParamName = 'DEFAULT_STAMP';

@Component({
  selector: 'app-draw-stamp-tools',
  templateUrl: './draw-stamp-tools.component.html',
  styleUrls: ['./draw-stamp-tools.component.css']
})
export class DrawStampToolsComponent implements OnInit {
  leadToolsHelper: LeadToolsHelper = new LeadToolsHelper();
  FontSizes = [];
  currentFont: string;
  currentFontSize = 12;
  currentFontStyle: string;
  currentFontStyleCustom: string;
  currentStampLocation: string;
  enumFonts = [];
  enumFontStyles = [];
  enumStampLocations = [];
  fontStyles = FontStyle;
  stampLocs = StampLocation;

  // Standard Stamp
  fontStdStamp: number;
  fontNameStdStamp: string;
  fontSizeStdStamp: number;
  fontStyleStdStamp: string;
  foregroundStdStamp: string;
  backgroundStdStamp: string;
  locationStdStamp: string;
  // Custom Stamp
  fontCustomStamp: number;
  fontNameCustomStamp: string;
  fontSizeCustomStamp: number;
  fontStyleCustomStamp: string;
  foregroundCustomStamp: string;
  backgroundCustomStamp: string;

  drawParameter: cfgDrawParameter;
  drawStampDefaults: DrawStampDefaults;

  constructor(private drawDefaultService: DrawDefaultsService, public configurationService: ConfigurationService,  private snackBar: MatSnackBar) {
    this.enumFonts = this.leadToolsHelper.enumFonts;
    this.enumFontStyles = this.leadToolsHelper.enumFontStyles;
    this.enumStampLocations = this.leadToolsHelper.enumStampLocations;
  }

  getDrawParameters(parameterName: string) {
    let promise = new Promise((resolve, reject) => {
      this.drawDefaultService.getDrawDefaults(parameterName)
        .subscribe(resolve, reject);
    });
    return promise;
  }

  ngOnInit(): void {

    for (let i = 6; i <= 25; i++) {
      let newSize = {
        value: i
      };
      this.FontSizes.push(newSize);
    }
    this.getDrawParameters(ParamName)
      .then((result: cfgDrawParameter) => {
        this.drawParameter = result;
        if (this.drawParameter == null) {
          this.setDefaultValues();
          this.drawStampDefaults = new DrawStampDefaults();
          this.saveDefaultValues();
          return
        }

        this.drawStampDefaults = JSON.parse(this.drawParameter.ParameterValue);
        // Standard Stamp
        this.fontStdStamp = this.drawStampDefaults.fontStdStamp;
        this.fontNameStdStamp = this.drawStampDefaults.fontNameStdStamp;
        this.fontSizeStdStamp = this.drawStampDefaults.fontSizeStdStamp;
        this.fontStyleStdStamp = this.drawStampDefaults.fontStyleStdStamp;
        this.foregroundStdStamp = this.drawStampDefaults.foregroundStdStamp;
        this.backgroundStdStamp = this.drawStampDefaults.backgroundStdStamp;
        this.locationStdStamp = this.drawStampDefaults.locationStdStamp;
        // Custom Stamp
        this.fontCustomStamp = this.drawStampDefaults.fontCustomStamp;
        this.fontNameCustomStamp = this.drawStampDefaults.fontNameCustomStamp;
        this.fontSizeCustomStamp = this.drawStampDefaults.fontSizeCustomStamp;
        this.fontStyleCustomStamp = this.drawStampDefaults.fontStyleCustomStamp;
        this.foregroundCustomStamp = this.drawStampDefaults.foregroundCustomStamp;
        this.backgroundCustomStamp = this.drawStampDefaults.backgroundCustomStamp;
      }, err => {
        this.setDefaultValues();
        this.drawStampDefaults = new DrawStampDefaults();
        this.saveDefaultValues();
      });

  }
  setDefaultValues() {
    // Standard Stamp
    this.fontStdStamp = 1;
    this.fontNameStdStamp = 'Verdana';
    this.fontSizeStdStamp = 12;
    this.fontStyleStdStamp = '0';
    this.foregroundStdStamp = '#f05b41';
    this.backgroundStdStamp = '#5341f0';
    this.locationStdStamp = '4';
    // Custom Stamp
    this.fontCustomStamp = 1;
    this.fontNameCustomStamp = 'Verdana';
    this.fontSizeCustomStamp = 12;
    this.fontStyleCustomStamp = '0';
    this.foregroundCustomStamp = '#f05b41';
    this.backgroundCustomStamp = '#5341f0';

  }
  saveDefaultValues() {
    this.drawStampDefaults.fontStdStamp = this.fontStdStamp;
    this.drawStampDefaults.fontSizeStdStamp = this.fontSizeStdStamp;
    this.drawStampDefaults.fontStyleStdStamp = this.fontStyleStdStamp;
    this.drawStampDefaults.foregroundStdStamp = this.foregroundStdStamp;
    this.drawStampDefaults.backgroundStdStamp = this.backgroundStdStamp;
    this.drawStampDefaults.locationStdStamp = this.locationStdStamp;
    // Custom Stamp
    this.drawStampDefaults.fontCustomStamp = this.fontCustomStamp;
    this.drawStampDefaults.fontSizeCustomStamp = this.fontSizeCustomStamp;
    this.drawStampDefaults.fontStyleCustomStamp = this.fontStyleCustomStamp;
    this.drawStampDefaults.foregroundCustomStamp = this.foregroundCustomStamp;
    this.drawStampDefaults.backgroundCustomStamp = this.backgroundCustomStamp;

  }

  onForegroundColorChangeStd(event: TdoColorPickerEvent) {
    this.foregroundStdStamp = event.hex;
  }
  onBackgroundColorChangeStd(event: TdoColorPickerEvent) {
    this.backgroundStdStamp = event.hex;
  }
  onFontChangeStd(e) {
    this.fontStdStamp = e.value.value;
    this.fontNameStdStamp = e.value.name;
  }
  onFontSizeChangeStd(e) {
    this.fontSizeStdStamp = e.value.value;
  }
  onFontStyleChangeStd(e) {
    this.fontStyleStdStamp = e.value.value;
    this.currentFontStyle = e.value.value;
  }
  onStampLocationChange(e) {
    this.locationStdStamp = e.value.value;
    this.currentStampLocation = e.value.value;
    this.drawStampDefaults.locationStdStamp = e.value.value;
  }
  onForegroundColorChangeCustom(event: TdoColorPickerEvent) {
    this.foregroundCustomStamp = event.hex;
  }
  onBackgroundColorChangeCustom(event: TdoColorPickerEvent) {
    this.backgroundCustomStamp = event.hex;
  }
  onFontChangeCustom(e) {
    this.fontCustomStamp = e.value.value;
    this.fontNameCustomStamp = e.value.name;
  }
  onFontSizeChangeCustom(e) {
    this.fontSizeCustomStamp = e.value.value;
  }
  onFontStyleChangeCustom(e) {
    this.fontStyleCustomStamp = e.value.value;
    this.currentFontStyleCustom = e.value.value;
  }

  async onSave(e) {
    this.saveDefaultValues();
    const drawParam = new DrawParameterObj();
    drawParam.parameterName = ParamName;
    const annDefaults = JSON.stringify(this.drawStampDefaults);
    drawParam.parameterValue = annDefaults;
    await this.drawDefaultService.saveDrawDefaults('00000000-0000-0000-0000-000000000000', drawParam).toPromise();
    this.createMessage('Configuration Saved', 'Success');
    this.configurationService.setClean();
  }

  createMessage(message, type) {
    this.snackBar.open(message, type, {
      duration: 3000,
      verticalPosition: 'top'
    });
  }


  getFont(fontStdStamp: number) {
    const val = this.enumFonts.find(p => p.value === fontStdStamp);
    if (val) {
      return val;
    }
  }

  getFontSize(fontSizeStdStamp: number) {
    const val = this.FontSizes.find(p => p.value === fontSizeStdStamp);
    if (val) {
      return val;
    }
  }

  getFontStyle(fontStyleStdStamp: string) {
    const val = this.enumFontStyles.find(p => p.value.toString() === fontStyleStdStamp.toString());
    if (val) {
      return val;
    }
  }

  getLocation(locationStdStamp: string) {
    const val = this.enumStampLocations.find(p => p.value.toString() === locationStdStamp.toString());
    if (val) {
      return val;
    }
  }

  dropdownChange($event: TdoDropdownChange) {
    if ($event.isUserInput) {
      this.configurationService.setDirty();
    }
  }
}
